import React from 'react';
// import './App.css';

const AboutUs = () => {
        return (
          <div className="container">
                  <header className="header">
                          <h1>Order Multi</h1>
                          <p>以优质的服务，低廉的价格，稳定的性能服务了千万家用户</p>
                  </header>
                  <section className="section">
                          <h2>解决方案</h2>
                          <ul>
                                  <li>顾客点餐</li>
                                  <li>后厨制作</li>
                                  <li>服务呼叫</li>
                                  <li>店员管理</li>
                                  <li>订单管理</li>
                                  <li>会员营销</li>
                                  <li>饭店私域流量保护</li>
                          </ul>
                  </section>
                  <section className="section">
                          <h2>目标</h2>
                          <p>规范并简化业务流程，帮助餐厅高效运营。</p>
                  </section>
                  <section className="section">
                          <h2>服务范围</h2>
                          <p>目前飞鸽点餐用户除中国外在欧洲、日本、越南、新加坡、葡萄牙、法国、英国、德国、西班牙、意大利、罗马尼亚、俄罗斯、印度伊朗、印度尼西亚、澳大利亚、菲律宾、加拿大、美国、智利等地服务于当地餐饮行业。</p>
                  </section>
                  <section className="section">
                          <h2>代理合作公司</h2>
                          <p>法国、西班牙、加拿大、越南、老挝、新加坡、新西兰、菲律宾等地。</p>
                  </section>
                  <section className="section">
                          <h2>开发者信息</h2>
                          <p>上海燃墨科技有限公司</p>
                  </section>

                  <footer className="footer">
                          <p>&copy; 2024 Order Multi. All rights reserved.</p>
                  </footer>
          </div>
        );
};

export default AboutUs;
